import SnapchatCameraContainer from 'src/components/common/special/SnapchatCameraContainer';


export const SnapchatCameraSandbox = () => {
    return(
        <SnapchatCameraContainer />
    )
}